module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"invoice_details":"Детали счета"},"en":{"invoice_details":"Invoice details"}}')
  delete Component.options._Ctor
}
